import styles from './Wrapper.module.css'
import type { ReactNode } from "react"

type Props = {
    children: ReactNode    
    bgColor: string
}

export default function Wrapper({children, bgColor}:Props) {
  return (
    <div style={{backgroundColor: bgColor}} className={`${styles.wrapper}`}>
        {children}
    </div>
  )
}
